import {makeAutoObservable, runInAction} from "mobx";
import debounce from 'lodash.debounce';
import {
    useFloating,
    useInteractions,
    useTransitionStatus
} from "@floating-ui/react";

type SidebarSettings = {
    floating?: Pick<ReturnType<typeof useFloating>, 'refs'>;
    transitionStatus?: ReturnType<typeof useTransitionStatus>;
    interactions?: Pick<ReturnType<typeof useInteractions>, 'getFloatingProps'|'getReferenceProps'>;
};

const TABLET_MAX_WIDTH = 1200;

class AppLayoutStore {
    private _windowWidth: number = 0;
    private _headerHeight: number = 0;
    private _isSidebarOpen: boolean = false;
    private _showFloatingSidebar: boolean = false;
    private _sidebarSettings: SidebarSettings = {};

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
        this._subscribeToWindowResize();
    }

    private _subscribeToWindowResize(): void {
        const onResize = () => {
            runInAction(() => {
                this._windowWidth = window.innerWidth;
                this._showFloatingSidebar = this._windowWidth <= TABLET_MAX_WIDTH;
            });
        };

        onResize();

        window.addEventListener('resize', debounce(onResize, 100));
    }

    get headerHeight(): number {
        return this._headerHeight;
    }

    set headerHeight(headerHeight: number) {
        this._headerHeight = headerHeight;
    }

    get isSidebarOpen(): boolean {
        return this._isSidebarOpen;
    }

    set isSidebarOpen(isOpen: boolean) {
        this._isSidebarOpen = isOpen;
    }

    get showFloatingSidebar() {
        return this._showFloatingSidebar;
    }

    get sidebarSettings(): SidebarSettings {
        return this._sidebarSettings ?? {};
    }

    set sidebarSettings(settings: SidebarSettings) {
        this._sidebarSettings = settings;
    }
}

export default new AppLayoutStore();